import { Box, Container, Typography, useTheme } from '@mui/material';

// Renderiza um documento legal a partir de uma estrutura de dados.
// Tipos de bloco suportados em cada seção:
//   { type: 'p', text }         -> parágrafo
//   { type: 'subheading', text} -> subtítulo dentro da seção
//   { type: 'list', items: [] } -> lista com marcadores
const Block = ({ block }) => {
  const theme = useTheme();

  if (block.type === 'subheading') {
    return (
      <Typography variant="h3" sx={{ fontSize: '1.25rem', mt: 3, mb: 1 }}>
        {block.text}
      </Typography>
    );
  }

  if (block.type === 'list') {
    return (
      <Box component="ul" sx={{ pl: 3, my: 1.5 }}>
        {block.items.map((item, i) => (
          <Typography
            component="li"
            variant="body1"
            key={i}
            sx={{ color: theme.palette.text.secondary, mb: 0.75, lineHeight: 1.7 }}
          >
            {item}
          </Typography>
        ))}
      </Box>
    );
  }

  return (
    <Typography
      variant="body1"
      sx={{ color: theme.palette.text.secondary, mb: 1.5, lineHeight: 1.75 }}
    >
      {block.text}
    </Typography>
  );
};

const LegalPage = ({ doc }) => {
  const theme = useTheme();
  const { title, subtitle, lastUpdated, sections } = doc;

  return (
    <Box>
      {/* Hero */}
      <Box sx={{ backgroundColor: theme.palette.text.primary, color: 'white' }}>
        <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
          <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '2.75rem' }, mb: 1 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="h4" sx={{ color: theme.palette.grey[100], mb: 2 }}>
              {subtitle}
            </Typography>
          )}
          <Typography variant="body2" sx={{ color: theme.palette.grey[100] }}>
            Última atualização: {lastUpdated}
          </Typography>
        </Container>
      </Box>

      {/* Corpo */}
      <Container maxWidth="md" sx={{ py: { xs: 5, md: 7 } }}>
        {sections.map((section, index) => (
          <Box component="section" key={index} sx={{ mb: 4 }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '1.4rem', md: '1.6rem' }, mb: 1.5 }}>
              {`${index + 1}. ${section.title}`}
            </Typography>
            {section.blocks.map((block, i) => (
              <Block block={block} key={i} />
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default LegalPage;
